import React from 'react';
import { UserProvider } from './../Providers/UserProvider'



export default class CatalogueNewsBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			error: null
		};
	}

	handleSubmit = (e) => {
		var T = window.Texts.newsBox;
		e.preventDefault();
		this.setState({ error: null });
		UserProvider.mailkitSignUp(this.state.email,
			() => {
				window.gtm.onRegistrationNews("news-box");
				alert(T.finish);
				this.setState({ email: '' });
			},
			(err) => {
				this.setState({ error: err });
			});
	}

	render() {
		var T = window.Texts.newsBox;
		return (
				<ul>
					<li><h4><b>{T.novinkyDoemailu}</b></h4></li>
					<li>
						<form class="form" id="newsLetterRow" onSubmit={(e) => this.handleSubmit(e)}>
							<input type="email" className={(this.state.error) ? 'form-control required email error' : 'form-control required email'} name="email" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} required="true" placeholder='' />
							{(this.state.error) ? <label id="Email-error" className="error" htmlFor="Email">{this.state.error}</label> : null}
							<button className="btn" type="submit" >{T.registrovat}</button>
						</form>
					</li>
				</ul>);
			}
}
//inicializace

var element = document.getElementById("app-cataloguenewsBox");
if (element) {
	ReactDOM.render(<CatalogueNewsBox />, element);
}

